import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { getApiUrl } from '../config/api'
import '../App.css'

function Footer() {
  const [pages, setPages] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch(getApiUrl('pages'))
      .then(response => response.json())
      .then(data => {
        setPages(data)
        setLoading(false)
      })
      .catch(error => {
        console.error('Error fetching pages:', error)
        setLoading(false)
      })
  }, [])

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>SkillSiksha</h4>
            <p>Your gateway to government jobs and career success. We provide comprehensive resources for exam preparation and job opportunities.</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              {!loading && pages.map((page) => {
                const path = page.link || `/${page.slug || page.title.toLowerCase().replace(/\s+/g, '-')}`
                return (
                  <li key={page.id}>
                    <Link to={path}>{page.title}</Link>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul>
              <li><i className="fas fa-envelope"></i> Prabhumeena3167@gmail.com</li>
              <li><i className="fas fa-phone"></i> +918290114167</li>
              <li><i className="fas fa-map-marker-alt"></i> Udaipur, India</li>
              <li>
                <a href="https://www.instagram.com/skillshiksha1?igsh=MW12NWRtdjAxdGN6eQ==" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>
                  <i className="fab fa-instagram"></i> Follow us on Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} SkillSiksha. All rights reserved.</p>
          <div style={{ marginTop: '1rem', display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/privacy-policy" style={{ color: 'inherit', textDecoration: 'none', fontSize: '0.9rem' }}>Privacy Policy</Link>
            <Link to="/disclaimer" style={{ color: 'inherit', textDecoration: 'none', fontSize: '0.9rem' }}>Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer

